import dbc from '@/api/virtual/vOrganize';

const listData = {
  namespaced: true,
  state: {
    roleCopySources: [],
    virtualOrgList: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    dictList: [],
    deptUserAllLists: [],
    // 所属类型
    TEAM_TYPE: [],
  },

  actions: {
    /**
     * 获取虚拟组织table-lsit
     */
    getVirtualList(context, param) {
      // param.pageSize = 9999999;
      // param.pageNum = 1;
      // return dbc.getVirtualList(param).then((content) => {
      //   commit('setVirtualList', content);
      // });
      return dbc.getVirtualList(param);
    },
    /* 数据字典-PDT和LMT-teamlist */
    getDictList({ commit }, param) {
      return dbc.getDictList(param).then((content) => {
        commit('setDictList', content);
      });
    },
    /* 获取部门组织架构 */
    getDeptUserAllListTreeVO({ commit }, param) {
      return dbc.getDeptUserAllListTreeVO(param).then((content) => {
        commit('setDeptUserAllListTreeVO', content);
      });
    },
    /* 根据数据字典查询teamList */
    getUsersByCode(context, param) {
      return dbc.getUsersByCode(param);
    },
    // 输入名字自动联想
    listByNameLike(store, param) {
      return dbc.listByNameLike(param);
    },
    // 根据ids获取用户列表
    getUserListByIds(store, param) {
      return dbc.getUserListByIds(param);
    },
    // 更新角色成员
    updateTeamUser(store, param) {
      return dbc.updateTeamUser(param);
    },
    // 获取产品详情
    getProductInfo(store, param) {
      return dbc.getProductInfo(param);
    },
    // 获取人员详情
    getUserList(store, param) {
      return dbc.getUserList(param);
    },
    // get 项目和专家组的团队及角色成员
    getTeamList(store, param) {
      return dbc.getTeamList(param);
    },
    // get 专家组card
    getProfessionList(store, param) {
      return dbc.getProfessionList(param);
    },
    // 获取团队datalist
    getTeamListData(store, param) {
      return dbc.getTeamListData(param);
    },
    // 获取角色datalist
    getRoleListData(store, param) {
      return dbc.getRoleListData(param);
    },
    // 所有团队
    teamListSource(store, param) {
      return dbc.teamListSource(param);
    },
    // 所有团队
    teamListSourceAll(store, param) {
      return dbc.teamListSourceAll(param);
    },
    // get角色
    getRoleSourcesFun(store, param) {
      return dbc.getRoleSourcesFun(param);
    },
    getRoleSourcesFunCopy({ commit }, param) {
      return dbc.getRoleSourcesFun(param).then((content) => {
        commit('setRoleSourcesFun', content);
      });
    },
    // 新增团队
    addTeamListFun(store, param) {
      return dbc.addTeamListFun(param);
    },
    // team getVo
    getTeamInfoFun(store, param) {
      return dbc.getTeamInfoFun(param);
    },
    // role add & edit
    addRoleList(store, param) {
      return dbc.addRoleList(param);
    },
    // get roleVo
    getRoleInfo(store, param) {
      return dbc.getRoleInfo(param);
    },
    /**
   * 获取数据字典信息
   * @param {*} param
   */
    getDictionarySources({ commit }, param) {
      return dbc.getDictionarySources(param).then((content) => {
        content.type = param.typeCode;
        commit('setDictionarySources', content);
      });
    },
  },

  mutations: {
    setDictionarySources(state, content) {
      state[content.type] = content.list;
    },
    // setVirtualList(state, content) {
    //   const returnObj = content.page || {};
    //   state.virtualOrgList.list = returnObj.list;
    //   state.virtualOrgList.pageNum = returnObj.pageNum;
    //   state.virtualOrgList.total = returnObj.total;
    // },
    setRoleSourcesFun(state, content) {
      const { list } = content;
      state.roleCopySources = list;
    },
    setDictList(state, content) {
      const { list } = content;
      state.dictList = list;
    },
    setDeptUserAllListTreeVO(state, content) {
      state.deptUserAllLists = content.data || [];
    },
  },
};

export default listData;
